import { Injectable } from '@angular/core';
import { User as LibraryUser, UserOptions, UsersServiceInterface } from '@vendasta/users';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AccountService } from '../core/account.service';
import { User as PCUser } from '../core/user';
import { UserService } from '../users';
import { VbcApiService } from '../users/vbc-api.service';

@Injectable()
export class AddUserService implements UsersServiceInterface {
  hasMoreResults$: Observable<boolean>;
  users$: Observable<LibraryUser[]>;

  constructor(
    private userService: UserService,
    private accountService: AccountService,
    private vbcApiService: VbcApiService,
  ) {
    this.users$ = this.userService.users$.pipe(
      filter((users) => !!users),
      map((users) => {
        return users.map((user) => this.pcToLibraryUser(user));
      }),
    );
    this.hasMoreResults$ = this.userService.hasMoreResults;
  }

  addUsersToAccount(partnerId: string, accountGroupId: string, userIds: string[]): Observable<unknown> {
    const usersArray = userIds.map((id) => {
      return {
        userId: id,
      } as PCUser;
    });
    return this.accountService.addUsersToAccount(partnerId, accountGroupId, usersArray);
  }

  createSMBUser(user: LibraryUser, userOptions: UserOptions): Observable<LibraryUser> {
    //TODO: Revisit this and re-enable email sending options in the future [PION-384].
    return this.vbcApiService
      .createUser(
        userOptions.partnerId,
        userOptions.accountGroupId,
        user.firstName,
        user.lastName,
        '',
        user.email,
        userOptions.phone || '',
        'false',
        '',
        '',
      )
      .pipe(map((user) => this.pcToLibraryUser(user)));
  }

  loadMore(): void {
    this.userService.loadMore();
  }

  search(query: string): void {
    this.userService.search(of(query)).pipe(take(1)).subscribe();
  }

  private pcToLibraryUser(pcUser: PCUser): LibraryUser {
    return {
      email: pcUser.email,
      userId: pcUser.userId,
      unifiedId: pcUser.unifiedUserId,
      firstName: pcUser.firstName,
      lastName: pcUser.lastName,
    } as LibraryUser;
  }
}
